module.exports = __webpack_public_path__ + "img/pakiet_4.3d4e28b0.svg";